import { Font } from "@react-pdf/renderer";
import { StyleSheet } from "@react-pdf/renderer";
import { PDF_EEG_EVALUATION_FONT_SIZE } from "../pdf/constants";
import { PDF_FOOTER_PAGE_PADDING_BOTTOM } from "../pdf/document-components/PdfFooter";

// Register fonts
Font.registerHyphenationCallback((word) => [word]);

Font.register({
    family: "Montserrat",
    fonts: [
        { src: "/fonts/Montserrat/static/Montserrat-Regular.ttf", fontWeight: 400 },
        { src: "/fonts/Montserrat/static/Montserrat-Bold.ttf", fontWeight: 700 },
        { src: "/fonts/Montserrat/static/Montserrat-Italic.ttf", fontWeight: 400, fontStyle: "italic" },
        { src: "/fonts/Montserrat/static/Montserrat-BoldItalic.ttf", fontWeight: 700, fontStyle: "italic" },
    ],
});

export const styles = StyleSheet.create({
    page: {
        padding: 40,
        paddingBottom: PDF_FOOTER_PAGE_PADDING_BOTTOM,
        fontFamily: "Montserrat",
        textAlign: "justify",
    },
    titleContainer: {
        alignItems: "center",
        marginBottom: 35,
    },
    title: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.title,
        fontFamily: "Montserrat",
        fontWeight: "bold",
        textAlign: "center",
    },
    secondPageTitle: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.title,
        fontFamily: "Montserrat",
        fontWeight: "bold",
        textAlign: "left",
    },
    subtitle: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.subtitle,
        fontWeight: "bold",
        textAlign: "left",
        marginTop: 5,
    },
    tableContainer: {
        flexDirection: "column",
    },
    topSection: {
        marginBottom: 15,
    },
    otherFields: {
        marginTop: 10,
        gap: 10
    },
    tableRow: {
        flexDirection: "row",
        marginBottom: 5,
    },
    tableLabel: {
        width: "36%",
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
        fontFamily: "Montserrat",
        fontWeight: "bold",
    },
    tableContent: {
        width: "64%",
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
    },

    column: {
        width: "48%",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    sectionTitle: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.subtitle,
        fontWeight: "bold",
        marginBottom: 10,
    },

    conectividadeSection: {
        marginTop: 10,
        marginBottom: 10,
    },
    sectionSubTitle: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.sectionSubtitle,
        fontWeight: 600,
        marginBottom: 10,
    },
    contentContainer: {
        marginBottom: 20,
    },
    text: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
        marginBottom: 5,
    },
    textSpacedJustified: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
        marginBottom: 0,
        textAlign: "justify" as const,
        lineHeight: 1.8,
        fontFamily: "Montserrat",
        textIndent: 20,
    },
    textBold: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
        marginBottom: 6,
        fontWeight: "bold",
    },
    centeredText: {
        textAlign: "center",
    },
    brainImage: {
        alignSelf: "center",
    },

    contentWrapper: {
        //flexGrow: 1,
        //flexShrink: 0,
        display: "flex",
        flexDirection: "column",
    },
    noteSection: {
        marginTop: 20,
        marginBottom: 20,
    },
    noteText: {
        fontSize: PDF_EEG_EVALUATION_FONT_SIZE.body,
    },

});
